import { KeyValueModel } from "model/api";
import { EnumDashboardPeriodo } from '../../model/enums/enum-dashboard-periodo';

export const PeriodoDashboardMock: KeyValueModel[] = [
    new KeyValueModel(EnumDashboardPeriodo.DIA, "Por dia"),
    new KeyValueModel(EnumDashboardPeriodo.MES, "Por mês"),
];